import { render, staticRenderFns } from "./ownerEdit.vue?vue&type=template&id=51595fff&scoped=true&"
import script from "./ownerEdit.vue?vue&type=script&lang=js&"
export * from "./ownerEdit.vue?vue&type=script&lang=js&"
import style0 from "./ownerEdit.vue?vue&type=style&index=0&id=51595fff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51595fff",
  null
  
)

export default component.exports